export class LocalStorageService {
    set(key: any, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    get(key: any): any {
        return JSON.parse(localStorage.getItem(key));
    }

    delete(key: any): void {
        localStorage.removeItem(key);
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/services/local-storage.service.ts